import { createReducer, on } from '@ngrx/store';
import { sessionActions } from '../actions/session.actions';

/** The authenticated context: whether a session exists, and what it may do. Identity lives in `profile`. */
export interface SessionState {
    loaded: boolean | null;
    permissions: string[];
    hasPermissionsWildcard: boolean;
}

export const initialState: SessionState = {
    loaded: null,
    permissions: [],
    hasPermissionsWildcard: false,
};

export const sessionReducer = createReducer(
    initialState,
    on(sessionActions.getSession, (state): SessionState => ({
        ...state,
        loaded: null,
    })),
    on(sessionActions.getSessionSuccess, (state, { payload }): SessionState => ({
        ...state,
        loaded: true,
        permissions: payload.permissions,
        hasPermissionsWildcard: payload.hasPermissionsWildcard,
    })),
    on(sessionActions.getSessionError, (state): SessionState => ({
        ...state,
        loaded: false,
        permissions: [],
        hasPermissionsWildcard: false,
    })),
    on(sessionActions.clear, (): SessionState => ({
        ...initialState,
    })),
);
